import React, { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import {FormattedDate, FormattedMessage, useIntl} from 'react-intl'
import Icon from 'components/Icon'
import Button from 'components/Button'
import { Flex as Loading } from 'components/Loading'
import { BrandContext } from 'CustomerApp'

import Row from './components/Row'
import messages from './messages'

const Th = ({ children }) => (
  <th scope="col" className="whitespace-nowrap sticky top-0 bg-gray-50 px-1 md:px-2 xl:px-4 py-2 xl:py-3 text-xs font-medium text-gray-600 uppercase tracking-wider text-left">
    { children }
  </th>
)

const CustomerVoiceSelectorsPage = (props) => {
  const { brand } = useContext(BrandContext)
  const { formatMessage } = useIntl()

  const [loading, setLoading] = useState(true)
  const [voiceSelectors, setVoiceSelectors] = useState([])

  useEffect(() => {
    fetch(`/rest/v2/customer/voiceselectors`, {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then((response) => response.json())
      .then(({ data }) => {
        setLoading(false)
        setVoiceSelectors(data)
      })
      .catch((err) => {
        window.alert(err)
      })
  }, [])


  return (
    <div className="w-full h-full flex w-full overflow-scroll">
      <div className="h-full overflow-scroll flex flex-col w-full">
        <table className="overflow-scroll relative table-fixed w-full">
          <thead>
            <tr className="whitespace-nowrap shadow sticky top-0">
              <Th><FormattedMessage {...messages.date} /></Th>
              <Th><FormattedMessage {...messages.creator} /></Th>
              <Th><FormattedMessage {...messages.link} /></Th>
              <Th />
            </tr>
          </thead>
          <tbody>
            { voiceSelectors.map((vs) => (
              <Row key={vs.id} {...vs} />
            )) }
          </tbody>
        </table>

        { loading &&
          <Loading />
        }

        { !voiceSelectors.length && !loading &&
          <Loading>
            <FormattedMessage {...messages.noResults} />
          </Loading>
        }
      </div>
    </div>
  )
}

export default CustomerVoiceSelectorsPage
